import {
  getBlockchainFromAddress,
  getRawAddress,
} from "@anaconda/core/blockchain/address"
import type { NftId } from "@anaconda/core/nft/types"
import { usePathname } from "next/navigation"

export enum ItemPageType {
  OVERVIEW = "overview",
  OFFERS = "offers",
  ACTIVITY = "activity",
}

export const getItemHref = (itemId: NftId) => {
  const rawAddress = getRawAddress(itemId)
  const blockchain = getBlockchainFromAddress(itemId)

  return `/${blockchain.toLowerCase()}/items/${rawAddress}`
}

const HREF_FACTORY_BY_PAGE_TYPE: Record<
  ItemPageType,
  (colletionId: NftId) => string
> = {
  [ItemPageType.OVERVIEW]: getItemHref,
  [ItemPageType.OFFERS]: (itemId) => `${getItemHref(itemId)}/offers`,
  [ItemPageType.ACTIVITY]: (itemId) => `${getItemHref(itemId)}/activity`,
}

export const useItemPageHref = (itemId: NftId, pageType: ItemPageType) =>
  HREF_FACTORY_BY_PAGE_TYPE[pageType](itemId)

export const useItemActiveLinkChecker = (
  itemId: NftId,
  pageType: ItemPageType,
) => {
  const pathname = usePathname()
  const expectedHref = useItemPageHref(itemId, pageType)

  return pathname === expectedHref
}

export const useCurrentItemPageType = (pathname: string | null = null) => {
  const currentPathname = usePathname()
  const targetPathname = pathname ?? currentPathname

  if (targetPathname.includes("/activity")) {
    return ItemPageType.ACTIVITY
  }

  if (targetPathname.includes("/offers")) {
    return ItemPageType.OFFERS
  }

  return ItemPageType.OVERVIEW
}
